import { ActionType } from "@ms/planner-actions/lib/local/ActionType";
/** A tuple of the supported ActionType values for PinnedTasksStore, for use in the registry */ export const PinnedTasksStoreActionTypes = [
    ActionType.PinTask,
    ActionType.UnpinTask,
    ActionType.HydratePinnedTasks,
    ActionType.CreateEntityFailedAction,
    ActionType.CreateEntitySucceededAction
];
